/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type UpdateProgramsManyMutationVariables = Types.Exact<{
  updates: Array<Types.Programs_Updates> | Types.Programs_Updates;
}>;

export type UpdateProgramsManyMutation = {
  __typename?: 'mutation_root';
  update_programs_many?: Array<{
    __typename?: 'programs_mutation_response';
    returning: Array<{ __typename?: 'programs'; id: string }>;
  } | null> | null;
};

export const UpdateProgramsManyDocument = `
    mutation UpdateProgramsMany($updates: [programs_updates!]!) {
  update_programs_many(updates: $updates) {
    returning {
      id
    }
  }
}
    ` as string &
  TypedDocumentNode<UpdateProgramsManyMutation, UpdateProgramsManyMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    UpdateProgramsMany: build.mutation<
      UpdateProgramsManyMutation,
      UpdateProgramsManyMutationVariables
    >({
      query: (variables) => ({ document: UpdateProgramsManyDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useUpdateProgramsManyMutation } = injectedRtkApi;
